<template>
  <div>

    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Filtres</h5>
        <div class="row">
          <div class="col-sm-3">
            <select class="browser-default custom-select"
               v-model="f_rliss">
              <option value="0">Tous les RLISS...</option>
              <option v-for="rl in rliss" :key="rl.rliss_id"
                :value="rl.rliss_id" v-text="rl.rliss_fr"></option>
            </select>
          </div>
          <div class="col-sm-3">
            <input class="form-control" type="text" placeholder="Fournisseur"
              v-model="f_fournisseur" />
          </div>
          <div class="col-sm-3">
            <div class="form-check">
              <label class="form-check-input">
              <input class="form-check-input" type="checkbox" v-model="f_avec">
                Exclure les fournisseurs avec comptes
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table table-sm table-bordered" style="table-layout: fixed">
      <thead>
        <tr>
          <th class="text-truncate" style="width: 160px">RLISS</th>
          <th class="text-truncate" >Fournisseur</th>
          <th class="text-truncate" >Statut</th>
          <th class="text-truncate" style="max-width: 160px;">Rapport</th>
          <th style="text-align: left; width: 320px;">Utilisateurs</th>
          <th style="text-align: center; width: 160px;"># sauvegardes</th>
          <th style="text-align: center; width: 160px;">Dernière m-à-j</th>
        </tr>
      </thead>
      <tbody>
        <OnFssAccesRow v-for='f in filteredFss' :fss="f" :key='f.agency_id'>
        </OnFssAccesRow>
      </tbody>
    </table>
  </div>
</template>

<script>
import OnFssAccesRow from '@/components/OnFssAccesRow.vue'

export default {
  name: 'FssAcces',
  data() { return{
    f_rliss: 0,
    f_avec: false,
    f_fournisseur: ""
  }},
  props: {
    fss: Array,
    rliss: Array
  },
  components: {
    OnFssAccesRow,
  },
  computed: {
    // filteredFss() {
    //   return this.fss;
    // }
    filteredFss() {
      return this.fss.filter(fss =>
        ((this.f_rliss==0 || fss.r_id==this.f_rliss) &&
         (!this.f_avec || fss.usr_count==0) &&
         (this.f_fournisseur=="" ||
            fss.agency_name.toUpperCase().indexOf(
              this.f_fournisseur.toUpperCase()) > -1)
       )
      )
    }
  },
  // methods: {
  //   percent(a, b) {
  //     if(b==0) return "n/a";
  //     return (100*a/b).toFixed(1) + "%";
  //   },
  //   remplis(a, b) {
  //     return a.toString() + "/" + b.toString();
  //   },
  //   url(id) {
  //     return '/on/comparaison/'+id;
  //   }
  // }
}
</script>
<style>
div.card {
  margin-bottom: 15px;
}
</style>
